import * as React from 'react';
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {removeNonNumeric} from "../assets/js/main";
import {Autocomplete, Checkbox, CircularProgress, FormControlLabel, FormGroup, TextField} from "@mui/material";
import NavBar from "../components/NavBar";
import {setLoading} from "../redux/loading/actions";
import {useSnackbar} from "notistack";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import {Clear} from "@mui/icons-material";
import HandleFetchData from "../plugin/HandleFetchData";


export default function CODRequest(props) {
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const selector = useSelector((st) => st)
  const {enqueueSnackbar} = useSnackbar();
  const {fetchData} = HandleFetchData()

  const [firstName, setFirstName] = React.useState('');
  const [lastName, setLastName] = React.useState('');
  const [listStateAndCity, setListStateAndCity] = React.useState([])
  const [textStateAndCity, setTextStateAndCity] = React.useState('')
  const [newStateAndCity, setNewStateAndCity] = React.useState(null)
  const [address, setAddress] = React.useState('');
  const [mobileNo, setMobileNo] = React.useState('');
  const [phoneNo, setPhoneNo] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [toDate, setToDate] = React.useState(null);




  // متد دریافت لیست استان ها
  const getStateAndCity = async (e) => {
    dispatch(setLoading(true))
    let fetch = await fetchData('nbl', 'GET', `/v1/Address/getStateCity`, '', "application/json", {
      "term": e
    }, 'postex')
    setListStateAndCity(fetch?.data)
    dispatch(setLoading(false))
  }

  return (
     <>
       <NavBar blue back/>

       <div className="container">
         <div className="agencyRequestPage">
           <div className="titlePage">
             <h1>{t("codRequest.t18")}</h1>
             {/*<p>{t("agencyRequest.t2")}</p>*/}
           </div>
           <div className="form">

             <div className="row">
               <div className="col-12 col-md-6">
                 <div className="input">
                   <label className="required">{t("codRequest.t1")}</label>
                   <input type="text" name="firstName" id="firstName"
                          value={firstName}
                          onChange={e => setFirstName(e.target.value)}/>
                 </div>
               </div>
               <div className="col-12 col-md-6">
                 <div className="input">
                   <label className="required">{t("codRequest.t2")}</label>
                   <input type="text" name="lastName" id="lastName"
                          value={lastName}
                          onChange={e => setLastName(e.target.value)}/>
                 </div>
               </div>

               <div className="col-12 col-md-6">
                 <div className="input">
                   <label className="required">{t("codRequest.t8")}</label>
                   <input type="text" name="mobileNo" className="numeric" inputMode='numeric' id="mobileNo"
                          value={mobileNo}
                          onChange={e => setMobileNo(removeNonNumeric(e.target.value))}/>
                 </div>
               </div>

               <div className="col-12 col-md-6">
                 <div className="input">
                   <label className="required">{t("codRequest.t3")}</label>
                   <input type="text" name="phoneNo" className="numeric" inputMode='numeric' id="phoneNo"
                          value={phoneNo}
                          onChange={e => setPhoneNo(removeNonNumeric(e.target.value))}/>
                 </div>
               </div>

               <div className="col-12 col-md-6">
                 <div className="input">
                   <label className="required">{t("codRequest.t9")}</label>
                   <input type="email" name="email" id="email"
                          value={email}
                          onChange={e => setEmail(e.target.value)}/>
                 </div>
               </div>

               <div className="col-12 col-md-6">
                 <div className="input">
                   <label className="required">{t("codRequest.t7")}</label>
                   <div className="date-picker">
                     <DatePicker
                        id="setToDate"
                        calendar={persian}
                        locale={persian_fa}
                        value={toDate}
                        onChange={e => setToDate(e)}
                     />
                     <button type="button" onClick={() => setToDate(null)} id="toDate">
                       <Clear/>
                     </button>
                   </div>
                 </div>
               </div>




               <div className="col-12 col-md-6">
                 <div className="input mb-3">
                   <label className="required">{t("codRequest.t13")}</label>
                   <Autocomplete
                      inputValue={textStateAndCity}
                      noOptionsText={t("autoComplete.t1")}
                      id="stateAndCity"
                      disablePortal
                      autoHighlight
                      loading={selector?.loading?.isLoading}
                      onChange={(e, value, reason) => {
                        if (reason === 'clear') {
                          setTextStateAndCity('')
                          setNewStateAndCity(null)
                        } else {
                          setTextStateAndCity(value?.name)
                          setNewStateAndCity(value)
                        }
                      }}
                      options={listStateAndCity || []}
                      getOptionLabel={(option) => option?.name}
                      renderInput={(params) =>
                         <TextField {...params}
                                    hiddenLabel
                                    size="small"
                                    placeholder={t("singleOrder.sender.t28")}
                                    onChange={(event) => {
                                      setTextStateAndCity(event?.target?.value)
                                      event?.target?.value?.length > 2 && getStateAndCity(event?.target?.value)
                                    }}
                                    InputProps={{
                                      ...params.InputProps,
                                      endAdornment: (
                                         <React.Fragment>
                                           {selector?.loading?.isLoading ? <CircularProgress style={{margin: '0 5px'}} size={20}/> : null}
                                           {params.InputProps.endAdornment}
                                         </React.Fragment>
                                      ),
                                    }}
                         />}
                   />
                 </div>
               </div>
               <div className="col-12 col-md-6">
                 <div className="input">
                   <label className="required">{t("codRequest.t15")}</label>
                   <input type="text" name="address" id="address"
                          value={address}
                          onChange={e => setAddress(e.target.value)}/>
                 </div>
               </div>





               <div className="col-12 col-md-6">
                 <div className="btnGroup_yellow mb-0">
                   <button className="btnFill justify-content-center m-0">
                     <span>{t("agencyRequest.t47")}</span>
                   </button>
                 </div>
               </div>
             </div>
           </div>
         </div>
       </div>
     </>
  )
}
